import { render, staticRenderFns } from "./File.vue?vue&type=template&id=73a5fe86&scoped=true"
import script from "@/controllers/componentHooks/inputs/file/index.js?vue&type=script&lang=js&external"
export * from "@/controllers/componentHooks/inputs/file/index.js?vue&type=script&lang=js&external"
import style0 from "./File.css?vue&type=style&index=0&id=73a5fe86&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a5fe86",
  null
  
)

export default component.exports